<!------------------------------------------------------------------------------
 File: BaseBackgroundOverlay 
 Created by Keni Williams <kenneth.williams@estuk.co.uk>.
 with: IntelliJ IDEA
 Date: 2019-03-13
 Time: 16:25
------------------------------------------------------------------------------->
<template>
    <div class="background-overlay"
        :class="{
            'background-overlay-opened':show
        }"
    ></div>
</template>

<script>
	export default {
		name: "BaseBackgroundOverlay",
		components: {},
		props: {
			show:false
        },
		created() {
		},
		destroyed() {
		},
		mounted() {

		},
		data() {
			return {}
		},
		methods: {},
		watch: {},
		computed: {}
	}
</script>



// WEBPACK FOOTER //
// app/Shared/Resources/Assets/js/components/base/BaseBackgroundOverlay.vue?4249c3fd